exports.BASE_URL = "https://trecent.in/server";
exports.SOCKET_URL = "https://trecent.in";

exports.API_ROUTES = {
    CONTACT: {
        JOB_APPLICATION: "/api/contact/job-application",
        UPLOAD_RESUME: '/api/contact/upload-resume'
    }
}